<template>
    <component :is="tag">
        <slot
            :proposalStep="step"
            :campaign="campaign"
            :proposal="proposal"
            :discount-codes="discountCodes"
            :affiliate-link="affiliateLink"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-proposal-step="patchProposalStep"
            :isLoading="isLoading"
            :is-completing-proposal="isCompletingProposal"
            :is-patching-proposal="isPatchingProposal"
            :errors="errors"
        />
    </component>
</template>
<script>
    import BaseProposalStepMixin from "../mixins/BaseProposalStepMixin";
    import {NAME_COMPENSATION} from '../../../constants/proposal-steps';

    export default {
        name: 'CompensationProvider',
        mixins: [
            BaseProposalStepMixin,
        ],
        computed: {
          step(){
              return this.proposalSteps[NAME_COMPENSATION]
          },
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadCampaign(),
                        this.loadProposal(),
                        this.loadDiscountCodes(),
                        this.loadAffiliateLink(),
                    ]);
                })
                .then(() => {
                    this.initProposalStep(this.step);
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        }
    }
</script>
